<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>Identy.AI</span>
    <span class="title-spacer"></span>
    <app-title-context-menu></app-title-context-menu>
  </mat-toolbar-row>

</mat-toolbar>